import { Button, Card, Col, Form, Input, Row, Typography, message } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBusinessInfo } from "redux-context/business";
import { UserState } from "redux-context/user";
import { updatePassword } from "services/SauceService";

const Account: React.FC = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const { loggedUser } = useSelector((state: UserState) => state.user);

  const onFinish = async () => {
    setLoading(true);
    const values = form.getFieldsValue(true);
    try {
      const response: any = await updatePassword(values);
      if (response.message) {
        message.success(response.message);
        dispatch(getBusinessInfo());
      }
    } catch (error) {
      console.log(error);
      message.error("Error updating account");
    }
    setLoading(false);
  };

  // if (editing) {
  return (
    <Card className="business-info">
      <Row justify="center">
        <Col
          xs={22}
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            padding: "0 48px",
          }}
        >
          <div style={{ width: "100%" }}>
            <Form
              form={form}
              initialValues={{ email: loggedUser.email }}
              onFinish={onFinish}
              layout="vertical"
            >
              <Typography.Title
                level={2}
                className="title"
                style={{ marginBottom: 32 }}
              >
                User Info
              </Typography.Title>
              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, message: "email is required!" }]}
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                label="Old password"
                name="oldPassword"
                rules={[{ required: true, message: "password is required!" }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="New Password"
                name="newPassword"
                rules={[{ required: true, message: "password is required!" }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="Confirm password"
                name="confirmPassword"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("newPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Password don't match"));
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Row justify="end">
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                </Button>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default Account;
